<template>
    <div v-if="!email_sent">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h2>{{trans('auth.ForgetPassword','Forget Password?')}}</h2><hr/>
            <span>{{trans('auth.send_reset',"We'll send you a link to reset your password.")}}</span>
        </div>
        <div class="modal-body">
            <div class="sibebar_container">
                <form @submit.prevent="forgetPassword" method="POST" role="form">
                    <div class="form-group">
                        <label for="email_address">{{trans('auth.EmailAddress','Email Address')}}</label>
                        <input type="email" v-model="reset_form.email" class="form-control" id="email_address" required>
                    </div>
                    <button type="submit" class="btn btn-blue btn-block">Reset</button>
                    <h4 class="m-t-20">{{trans('auth.DontHaveAnAccount',"Don't have an account?")}} <a href="Javascript:void(0);" @click="setAuthModalType('signup')">{{trans('auth.SIGNUP','SIGN UP')}}</a></h4>
                    <div class="overlay-loader" v-if="isLoading">
                        <i class="overlay-img-load"></i>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h2>{{trans('auth.CheckYourInbox','Check Your Inbox')}}</h2>
            <hr/>
            <span>
               {{trans('auth.matchAccountDesc',"If that email matches an account, you'll get a link to reset your password within a few minutes.")}}
            </span>
        </div>
        <div class="modal-body">
            <button type="button" class="btn btn-blue btn-block" @click="setAuthModalType('login')">{{trans('auth.GOBack','Go Back To Login')}}</button>
        </div>
    </div>
</template>
<script>
import {mapState, mapActions} from "vuex";
import DataService from "../services/DataService";
export default {
    name: 'ForgetPasswordFrom',
    computed:{
        ...mapState(['isLoading']),
    },

    data() {
        return {
            reset_form:{
                email: ''
            },
            email_sent: false
        }
    },
    methods: {
        trans(key, defaultValue,msg=null) {
            let translation = '';
            if(msg){
                translation = this.$t(key,{message:msg});
            }else{
                translation = this.$t(key);
            }
            return translation !== key ? translation : defaultValue;
        },
        forgetPassword() {
            let _this = this;
            _this.$store.dispatch('setLoading',{'loading': true});
            DataService.forgetPassword(_this.reset_form).then(res => {
                _this.$store.dispatch('setLoading',{'loading': false});
                _this.email_sent = true;
            })
                .catch(error => {
                    _this.$store.dispatch('setLoading',{'loading': false});
                    _this.email_sent = false;
                    swal({
                        title: "Error!",
                        text: error.response ? error.response.data.message : error,
                        // type: "error",
                        imageUrl: "/images/warning-alert.png",  // Replace with the path to your custom image
                        showConfirmButton: true
                    });
                })
        },
        ...mapActions(['setAuthModalType'])
    }
}
</script>
